import PropTypes from "prop-types";
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { translator } from "../utils/i18n";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export default function AlertPaymentDetails(props) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const handleSubmit = () => {
    if (props.handleValidate) {
      props.handleValidate();
    }
    handleClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        disableBackdropClick={true}
        maxWidth="md"
      >
        <DialogTitle
          style={{ backgroundColor: "#2A928A", color: "#ACD5D1" }}
          className="head-dialog"
          id="scroll-dialog-title"
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {props.validate && (
              <CheckCircleIcon fontSize="large" style={{ margin: "2%" }} />
            )}
            <div style={{ color: "white" }}>{props.title}</div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div>{props.content}</div>
          <div className="wrap-btn">
            <button
              className="custom-btn"
              style={{ backgroundColor: "#2A928A" }}
              onClick={handleSubmit}
            >
              {translator()._("W_VALIDER")}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

AlertPaymentDetails.propTypes = {
  content: PropTypes.any,
  handleValidate: PropTypes.func,
  title: PropTypes.string,
  validate: PropTypes.bool
};
